import React, { useState } from 'react';
import { Poppins } from 'src/common';
import Input from 'src/components/form/Input';
import styled from 'styled-components';

const Div = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

interface ApplicableCheckProps {}

export const ApplicableCheck: React.FC<ApplicableCheckProps> = () => {
  const [checked, setChecked] = useState(false);

  return (
    <Div
      onClick={(e) => {
        e.stopPropagation();
        setChecked(!checked);
      }}
    >
      <Input checked={checked} className="switch" type="checkbox" />{' '}
      <Poppins px={14} color="davysGrey">
        {checked ? 'Yes' : 'No'}
      </Poppins>
    </Div>
  );
};
